import React, {useContext, useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {batchAmlImg, singleAmlImg} from '../../../assets/images/images';
import * as Actions from '../../../store/actions';
import {Loader} from '../../../components';
import {PAGES_URL} from '../../../helpers/constants';
import PerformLookupModal from '../PerformLookupModal';
import BatchAmlModal from './BatchAmlModal';
import {PageContext} from '../../../helpers/context';
import Layout from '../Layout';
import {ViewLink} from '../../../components/lookupComponents';
import {getLighterShade} from 'routes/EasyOnboard/colorUtils';

function UserScreening({auth: {userDetails}, apps: {allApps}, getAllApps}) {
  const [openSingleAml, setOpenSingleAml] = useState(false);
  const [singleAmlStep, singleAmlSetStep] = useState(1);
  const [openBatchAml, setOpenBatchAml] = useState(false);
  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('amllookup');
  }, [setPageName]);

  useEffect(() => {
    getAllApps({limit: 10000});
  }, [getAllApps]);

  const {viewSingleIndividualLookup, viewBatchIndividualLookup} =
    useMemo(
      () => userDetails?.permissions?.amlScreeningPermissions,
      [userDetails],
    ) || {};

  const baseColor = userDetails?.company?.color_code || '#3f7cdb';
  const lighterShade = getLighterShade(baseColor, 96);

  return (
    <Layout>
      <PerformLookupModal
        open={openSingleAml}
        setOpen={setOpenSingleAml}
        lookupType="Single"
        step={singleAmlStep}
        setStep={singleAmlSetStep}
      />

      <BatchAmlModal open={openBatchAml} setOpen={setOpenBatchAml} />

      {!allApps ? (
        <Loader height={35} />
      ) : (
        <>
          <div className="flex flex-col mt-6 sm:flex-row items-stretch gap-10 sm:gap-4 lg:gap-10">
            <div
              style={{
                backgroundColor: lighterShade,
                borderColor: 'rgba(230, 240, 255, 0.5)',
              }}
              className="rounded-xl pb-0 flex flex-col items-start sm:max-w-[406px] w-full border"
            >
              <div className="py-8 px-6 w-full">
                <h2 className="text-deepBlue mb-1 text-lg font-semibold">
                  Perform Single AML
                </h2>
                <p className="text-[#8E90A9] w-full border tracking-[-0.01em] border-transparent text-base font-light">
                  Screen your user effortlessly
                </p>
                <div className="w-full flex flex-col mt-8 lg:flex-row items-start lg:items-center gap-2">
                  {/* <PerformBtn
                  btnText="Perform Single AML"
                  permitted={performSingleIndividualLookup}
                  setOpen={setOpenSingleAml}
                  isCompanyVerified={isCompanyVerified}
                /> */}
                  <ViewLink
                    permitted={viewSingleIndividualLookup}
                    route={PAGES_URL.AML_USER_SCREENING_SINGLE}
                  />
                </div>
              </div>
              <div className="mt-auto lg:mt-14 flex justify-center w-full">
                <img src={singleAmlImg} alt="" width={347} height={224} />
              </div>
            </div>

            <div
              style={{
                backgroundColor: lighterShade,
                borderColor: 'rgba(230, 240, 255, 0.5)',
              }}
              className="rounded-xl pb-0 flex flex-col items-start sm:max-w-[406px] w-full border"
            >
              <div className="py-8 px-6 w-full">
                <h2 className="text-deepBlue text-lg font-semibold">
                  Perform Batch AML
                </h2>
                <p className="text-[#8E90A9] w-full border tracking-[-0.01em] border-transparent text-base font-light">
                  Upload and examine multiple users
                </p>
                <div className="w-full flex flex-col mt-8 lg:flex-row items-start lg:items-center gap-2">
                  {/* <PerformBtn
                  btnText="Perform Batch AML"
                  permitted={performBatchIndividualLookup}
                  setOpen={setOpenBatchAml}
                  isCompanyVerified={isCompanyVerified}
                /> */}
                  <ViewLink
                    permitted={viewBatchIndividualLookup}
                    route={PAGES_URL.AML_USER_SCREENING_BATCH}
                  />
                </div>
              </div>
              <div className="mt-14 flex justify-center w-full opacity-70">
                <img src={batchAmlImg} alt="" width={329} height={236} />
              </div>
            </div>
          </div>
        </>
      )}
    </Layout>
  );
}

export default connect(state => state, Actions)(UserScreening);
